import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import VueScrollTo from "vue-scrollto";
import jquery from "jquery";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import "@stripe/stripe-js";

import DeliveryRuleDialog from "@/components/dialogs/DeliveryRule";
import DeliveryIndicator from "@/components/DeliveryIndicator";

Vue.config.productionTip = false;

Vue.use(VueClipboard);
Vue.use(VueScrollTo);

window.$ = jquery;
window.jQuery = jquery;

Vue.component(DeliveryRuleDialog.name, DeliveryRuleDialog);
Vue.component(DeliveryIndicator.name, DeliveryIndicator);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// disable
// - right-click context menu
// - drag
const handleContextMenu = (eventName) => {
  if (document.addEventListener) {
    document.addEventListener(eventName, (e) => {
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      e.cancelBubble = true;
    }, false);
  } else {
    document.attachEvent(`on${eventName}`, () => {
      window.event.returnValue = false;
    });
  }
};
if (process.env.NODE_ENV === "production") {
  handleContextMenu("contextmenu");
  handleContextMenu("dragstart");
}